import { createTheme } from "@material-ui/core/styles";
import { esES } from "@material-ui/core/locale";
import stylesTheme from "./stylesTheme";
import {
  MuiTable,
  MuiChip,
  MuiForm,
  MuiDialog,
  MuiCircularProgress,
} from "./overrides";
import { FONT_WEIGHT } from "./typography";

const theme = createTheme(
  {
    overrides: {
      MuiToolbar: {
        root: {
          display: "flex",
          justifyContent: "space-between",
        },
      },
      MuiListItemIcon: {
        root: {
          minWidth: "3rem",
          justifyContent: "center",
        },
      },
      MuiButton: {
        root: {
          fontWeight: FONT_WEIGHT.semiBold,
          fontSize: stylesTheme.typography.pxToRem(16),
          textTransform: "none",
        },
        contained: {
          color: stylesTheme.palette.buttonDefault.text,
          fontWeight: 600,
          backgroundColor: stylesTheme.palette.buttonDefault.main,
        },
        containedPrimary: {
          color: stylesTheme.palette.buttonPrimary.text,
          backgroundColor: stylesTheme.palette.buttonPrimary.main,
          "&:hover": {
            backgroundColor: stylesTheme.palette.buttonPrimary.dark,
          },
        },
        containedSecondary: {
          color: stylesTheme.palette.buttonDefault.text,
          backgroundColor: stylesTheme.palette.buttonDefault.main,
          "&:hover": {
            backgroundColor: stylesTheme.palette.buttonDefault.dark,
          },
        },
      },
      MuiSvgIcon: {
        fontSizeLarge: {
          fontSize: "2.5rem",
        },
        colorSecondary: {
          color: stylesTheme.palette.text.secondary,
        },
      },
      MuiTabs: {
        indicator: {
          backgroundColor: stylesTheme.palette.secondary.main,
          height: stylesTheme.spacing(0.375),
          borderRadius: stylesTheme.shape.borderRadius,
        },
      },
      MuiTab: {
        root: {
          fontSize: stylesTheme.typography.pxToRem(20),
          fontWeight: stylesTheme.typography.fontWeightRegular,
          textTransform: "none",
          minWidth: "auto",
        },
      },
      ...MuiCircularProgress,
      ...MuiForm,
      ...MuiChip,
      ...MuiTable,
      ...MuiDialog,
    },
  },
  stylesTheme,
  esES /* TODO: when internationalization is implemented this locale must be dynamic */
);

export default theme;
